// Module
var code = "<div class=\"full-size\">\n    <div ng-if=\"::$ctrl.i18nStatusMap\" class=\"full-center md-h-padded pdf-viewer-status\" ng-i18next=\"[html:i18next]($ctrl.statusData){{$ctrl.i18nStatusMap + '.' + $ctrl.status}}\"></div>\n    <canvas class=\"pdf-viewer-content\"></canvas>\n</div>\n";
// Exports
module.exports = code;